// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: atk/health.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Point } from "../geo/geo";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.atk";

/** HealthLogs is a list of HealthLog entries */
export interface HealthLogs {
  healthLog: HealthLog[];
}

/**
 * HealthLog is a single point in time capture of the state of an autotractor.
 * we expect minute resolution for ops center display
 */
export interface HealthLog {
  Timestamp: string | undefined;
  location: Point | undefined;
  fuelLevelPercent: number;
  headingDegrees: number;
  /**
   * Deprecated: speed is sourced as a floating-point value on the robot and
   * was being rounded to a whole MPH to fit this int32. Use ground_speed_mph
   * instead, which preserves the original precision.
   *
   * @deprecated
   */
  speedMph: number;
  autonomyAuthorized: boolean;
  atkJobId: number;
  driverUserId: string;
  watcherUserId: string;
  activeFieldId: string;
  /**
   * Ground speed in MPH. Sourced directly from the tractor's floating-point
   * ground speed without rounding (replaces the deprecated int32 speed_mph).
   */
  groundSpeedMph: number;
  /**
   * Software version tag running on the tractor; "DEVELOPMENT" when not
   * running a release. Empty from tractors that predate this field.
   */
  softwareVersion: string;
}

function createBaseHealthLogs(): HealthLogs {
  return { healthLog: [] };
}

export const HealthLogs: MessageFns<HealthLogs> = {
  encode(message: HealthLogs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.healthLog) {
      HealthLog.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HealthLogs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHealthLogs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.healthLog.push(HealthLog.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HealthLogs {
    return {
      healthLog: globalThis.Array.isArray(object?.healthLog)
        ? object.healthLog.map((e: any) => HealthLog.fromJSON(e))
        : globalThis.Array.isArray(object?.health_log)
        ? object.health_log.map((e: any) => HealthLog.fromJSON(e))
        : [],
    };
  },

  toJSON(message: HealthLogs): unknown {
    const obj: any = {};
    if (message.healthLog?.length) {
      obj.healthLog = message.healthLog.map((e) => HealthLog.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HealthLogs>, I>>(base?: I): HealthLogs {
    return HealthLogs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HealthLogs>, I>>(object: I): HealthLogs {
    const message = createBaseHealthLogs();
    message.healthLog = object.healthLog?.map((e) => HealthLog.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHealthLog(): HealthLog {
  return {
    Timestamp: undefined,
    location: undefined,
    fuelLevelPercent: 0,
    headingDegrees: 0,
    speedMph: 0,
    autonomyAuthorized: false,
    atkJobId: 0,
    driverUserId: "",
    watcherUserId: "",
    activeFieldId: "",
    groundSpeedMph: 0,
    softwareVersion: "",
  };
}

export const HealthLog: MessageFns<HealthLog> = {
  encode(message: HealthLog, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.Timestamp), writer.uint32(10).fork()).join();
    }
    if (message.location !== undefined) {
      Point.encode(message.location, writer.uint32(18).fork()).join();
    }
    if (message.fuelLevelPercent !== 0) {
      writer.uint32(24).int32(message.fuelLevelPercent);
    }
    if (message.headingDegrees !== 0) {
      writer.uint32(33).double(message.headingDegrees);
    }
    if (message.speedMph !== 0) {
      writer.uint32(40).int32(message.speedMph);
    }
    if (message.autonomyAuthorized !== false) {
      writer.uint32(48).bool(message.autonomyAuthorized);
    }
    if (message.atkJobId !== 0) {
      writer.uint32(56).uint64(message.atkJobId);
    }
    if (message.driverUserId !== "") {
      writer.uint32(66).string(message.driverUserId);
    }
    if (message.watcherUserId !== "") {
      writer.uint32(74).string(message.watcherUserId);
    }
    if (message.activeFieldId !== "") {
      writer.uint32(82).string(message.activeFieldId);
    }
    if (message.groundSpeedMph !== 0) {
      writer.uint32(89).double(message.groundSpeedMph);
    }
    if (message.softwareVersion !== "") {
      writer.uint32(98).string(message.softwareVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HealthLog {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHealthLog();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = Point.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fuelLevelPercent = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.headingDegrees = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.speedMph = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.autonomyAuthorized = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.atkJobId = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.driverUserId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.watcherUserId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.activeFieldId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.groundSpeedMph = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.softwareVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HealthLog {
    return {
      Timestamp: isSet(object.Timestamp) ? globalThis.String(object.Timestamp) : undefined,
      location: isSet(object.location) ? Point.fromJSON(object.location) : undefined,
      fuelLevelPercent: isSet(object.fuelLevelPercent)
        ? globalThis.Number(object.fuelLevelPercent)
        : isSet(object.fuel_level_percent)
        ? globalThis.Number(object.fuel_level_percent)
        : 0,
      headingDegrees: isSet(object.headingDegrees)
        ? globalThis.Number(object.headingDegrees)
        : isSet(object.heading_degrees)
        ? globalThis.Number(object.heading_degrees)
        : 0,
      speedMph: isSet(object.speedMph)
        ? globalThis.Number(object.speedMph)
        : isSet(object.speed_mph)
        ? globalThis.Number(object.speed_mph)
        : 0,
      autonomyAuthorized: isSet(object.autonomyAuthorized)
        ? globalThis.Boolean(object.autonomyAuthorized)
        : isSet(object.autonomy_authorized)
        ? globalThis.Boolean(object.autonomy_authorized)
        : false,
      atkJobId: isSet(object.atkJobId)
        ? globalThis.Number(object.atkJobId)
        : isSet(object.atk_job_id)
        ? globalThis.Number(object.atk_job_id)
        : 0,
      driverUserId: isSet(object.driverUserId)
        ? globalThis.String(object.driverUserId)
        : isSet(object.driver_user_id)
        ? globalThis.String(object.driver_user_id)
        : "",
      watcherUserId: isSet(object.watcherUserId)
        ? globalThis.String(object.watcherUserId)
        : isSet(object.watcher_user_id)
        ? globalThis.String(object.watcher_user_id)
        : "",
      activeFieldId: isSet(object.activeFieldId)
        ? globalThis.String(object.activeFieldId)
        : isSet(object.active_field_id)
        ? globalThis.String(object.active_field_id)
        : "",
      groundSpeedMph: isSet(object.groundSpeedMph)
        ? globalThis.Number(object.groundSpeedMph)
        : isSet(object.ground_speed_mph)
        ? globalThis.Number(object.ground_speed_mph)
        : 0,
      softwareVersion: isSet(object.softwareVersion)
        ? globalThis.String(object.softwareVersion)
        : isSet(object.software_version)
        ? globalThis.String(object.software_version)
        : "",
    };
  },

  toJSON(message: HealthLog): unknown {
    const obj: any = {};
    if (message.Timestamp !== undefined) {
      obj.Timestamp = message.Timestamp;
    }
    if (message.location !== undefined) {
      obj.location = Point.toJSON(message.location);
    }
    if (message.fuelLevelPercent !== 0) {
      obj.fuelLevelPercent = Math.round(message.fuelLevelPercent);
    }
    if (message.headingDegrees !== 0) {
      obj.headingDegrees = message.headingDegrees;
    }
    if (message.speedMph !== 0) {
      obj.speedMph = Math.round(message.speedMph);
    }
    if (message.autonomyAuthorized !== false) {
      obj.autonomyAuthorized = message.autonomyAuthorized;
    }
    if (message.atkJobId !== 0) {
      obj.atkJobId = Math.round(message.atkJobId);
    }
    if (message.driverUserId !== "") {
      obj.driverUserId = message.driverUserId;
    }
    if (message.watcherUserId !== "") {
      obj.watcherUserId = message.watcherUserId;
    }
    if (message.activeFieldId !== "") {
      obj.activeFieldId = message.activeFieldId;
    }
    if (message.groundSpeedMph !== 0) {
      obj.groundSpeedMph = message.groundSpeedMph;
    }
    if (message.softwareVersion !== "") {
      obj.softwareVersion = message.softwareVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HealthLog>, I>>(base?: I): HealthLog {
    return HealthLog.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HealthLog>, I>>(object: I): HealthLog {
    const message = createBaseHealthLog();
    message.Timestamp = object.Timestamp ?? undefined;
    message.location = (object.location !== undefined && object.location !== null)
      ? Point.fromPartial(object.location)
      : undefined;
    message.fuelLevelPercent = object.fuelLevelPercent ?? 0;
    message.headingDegrees = object.headingDegrees ?? 0;
    message.speedMph = object.speedMph ?? 0;
    message.autonomyAuthorized = object.autonomyAuthorized ?? false;
    message.atkJobId = object.atkJobId ?? 0;
    message.driverUserId = object.driverUserId ?? "";
    message.watcherUserId = object.watcherUserId ?? "";
    message.activeFieldId = object.activeFieldId ?? "";
    message.groundSpeedMph = object.groundSpeedMph ?? 0;
    message.softwareVersion = object.softwareVersion ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
